import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen, Tags, Truck, LayoutGrid, Megaphone, Users } from 'lucide-react';
import { useFormAuth } from './FormacionAccess';
import CustomTooltip from '../../elementos/eventos/avisos/Tooltip';

/**
 * Submenú del módulo Formación para la franja gris global de Sidebar.js.
 * Dos grupos: LAE Formación (azul) y Cursos SEPE (naranja).
 * SEPE legacy ("Convocatoria", id 0) sigue vivo hasta migrar datos y retirarlo.
 */

function headerStyle(color, collapsed = false) {
  return {
    padding: collapsed ? '14px 4px 4px 15px' : '14px 12px 4px',
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color,
    listStyle: 'none',
    pointerEvents: 'none',
    userSelect: 'none',
    textAlign: 'left',
  };
}

function MenuItem({ to, end, Icon, label, showSidebar, iconColor, className }) {
  return (
    <li>
      <NavLink activeclassname="active" end={end} to={to} className={className}>
        <div className={`menuBtn ${showSidebar ? 'expanded' : 'collapsed'}`}>
          {showSidebar ? (
            <>
              <Icon style={iconColor ? { color: iconColor } : undefined} />
              <span className="menuText">{label}</span>
            </>
          ) : (
            <CustomTooltip mensaje={label} alineado="left" tamano="1.0rem">
              <div>
                <Icon style={iconColor ? { color: iconColor } : undefined} />
              </div>
            </CustomTooltip>
          )}
        </div>
      </NavLink>
    </li>
  );
}

const SEPE_ORANGE = '#f97316';

export default function FormacionSidebar({ showSidebar = true }) {
  const { can, permisosCargados } = useFormAuth();
  if (!permisosCargados) return null;

  // LAE
  const verCursosLae = can('formacion.lae.cursos.view');
  const verCategorias = can('formacion.lae.categorias.view');
  const verProveedores = can('formacion.proveedores.view');
  const hayLae = verCursosLae || verCategorias || verProveedores;

  // SEPE
  const verAreas = can('formacion.sepe.areas.view');
  const verConvocatorias = can('formacion.sepe.convocatorias.view');
  const verCursosSepe = can('formacion.sepe.cursos.view'); // existirá en Pieza B
  const verAlumnos = can('formacion.sepe.alumnos.view');
  const haySepe = verAreas || verConvocatorias || verCursosSepe || verAlumnos;

  return (
    <>
      {/* — LAE Formación (azul) — */}
      {hayLae && <li style={headerStyle('#64748b', !showSidebar)}>{showSidebar ? 'LAE Formación' : 'LF'}</li>}
      {verCursosLae && <MenuItem to="/formacion/lae/cursos" Icon={BookOpen} label="Cursos" showSidebar={showSidebar} />}
      {verCategorias && <MenuItem to="/formacion/lae/categorias" Icon={Tags} label="Categorías" showSidebar={showSidebar} />}
      {verProveedores && <MenuItem to="/formacion/proveedores" Icon={Truck} label="Proveedores" showSidebar={showSidebar} />}

      {/* — Tus Cursos SEPE (fondo activo naranja, iconos blancos vía clase `sepe`) — */}
      {haySepe && <li style={headerStyle(SEPE_ORANGE, !showSidebar)}>{showSidebar ? 'Tus Cursos SEPE' : 'TCS'}</li>}
      {verCursosSepe && <MenuItem to="/formacion/sepe/cursos" Icon={BookOpen} label="Cursos" showSidebar={showSidebar} className="sepe" />}
      {verAreas && <MenuItem to="/formacion/sepe/areas" Icon={LayoutGrid} label="Áreas" showSidebar={showSidebar} className="sepe" />}
      {verConvocatorias && <MenuItem to="/formacion/sepe/convocatorias" Icon={Megaphone} label="Convocatorias" showSidebar={showSidebar} className="sepe" />}
      {verAlumnos && <MenuItem to="/formacion/sepe/alumnos-potenciales" Icon={Users} label="Potenciales" showSidebar={showSidebar} className="sepe" />}
    </>
  );
}
